import { css } from '@emotion/react';
import { cssStringToBuilderReturnType } from '../commonUtils';
import { GapUnits } from '../../types';
export const buildSlideshowStyles = _ref => {
  let {
    selectors: {
      itemSelector,
      parentSelector
    },
    horizontalGap = 0,
    horizontalGapUnit = GapUnits.px
  } = _ref;
  const parentCss = css({
    [parentSelector]: {
      display: 'flex',
      scrollSnapType: 'x mandatory',
      overflow: 'auto',
      scrollbarWidth: 'none',
      height: '100%',
      width: '100%'
    }
  }).styles;
  const itemCss = css({
    [`${itemSelector}:nth-child(n)`]: {
      flex: '0 0 100%',
      scrollSnapAlign: 'center',
      marginRight: horizontalGap + horizontalGapUnit
    }
  }).styles;
  return cssStringToBuilderReturnType(parentCss + itemCss);
};
//# sourceMappingURL=slideshowBuilder.js.map